import { Injectable } from "@angular/core";
import { PlacardEditionRequest } from "../../api/models/placardEdit";
import { PlacardLocation } from "../../interface/upplm.placardInformation";

@Injectable()

export class PlacardLocationDetailsHelperService {

    constructor() { }

    preparePlacardLocationDetailsForEdit(data: PlacardLocation): any {

        return data;

    }

    prepareSaveEditionRequest(editedPlacardLocationData: PlacardLocation): PlacardEditionRequest {

        let placardEditionRequest = new PlacardEditionRequest();

        placardEditionRequest.metalBoxInd = editedPlacardLocationData.metalBoxInd;
        placardEditionRequest.lockCombination = editedPlacardLocationData.metalBoxInd ? editedPlacardLocationData.lockCombination: null;
        placardEditionRequest.pickupLocation = editedPlacardLocationData.pickupLocation;
        placardEditionRequest.placardLocation = editedPlacardLocationData.placardLocation;
        placardEditionRequest.additionalLocationDetails = editedPlacardLocationData.additionalLocationDetails;

        return placardEditionRequest;
    }
}